<template>
  <section class="search-page">
    <SearchHeader :totalCountSearch="totalCountSearch?.totalItem" />
    <SearchResults />
  </section>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'
import { useSectionsStore } from '@/stores/section'
import { storeToRefs } from 'pinia'

const sectionsStore = useSectionsStore()
const { searchItems } = storeToRefs(sectionsStore)

const totalCountSearch = computed(() => searchItems.value)

const SearchHeader = defineAsyncComponent(() => import('@/components/search/SearchHeader.vue'))
const SearchResults = defineAsyncComponent(() => import('@/components/search/SearchResults.vue'))
</script>

<style lang="scss">
@import '@/assets/scss/views/search-page';
</style>
